import React from "react";
import { formatted } from "../utils";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function DOLBreakdownTooltip({ dolAdditionalOT, dolBreakdown }) {
  if (!dolBreakdown || parseFloat(dolAdditionalOT) <= 0) {
    return null;
  }

  return (
    <div className="relative group inline-flex items-center gap-1">
      <span>DOL Additional OT: {formatted(dolAdditionalOT)}</span>
      <div className="peer cursor-pointer text-gray-500 hover:text-gray-700 -mt-1">
        <InfoOutlinedIcon style={{ fontSize: 16 }} />
      </div>

      {/* Tooltip Content */}
      <div className="absolute bottom-full left-0 mb-2 w-80 bg-gray-200 text-sm px-3 py-2 rounded opacity-0 hidden peer-hover:opacity-100 peer-hover:block transition duration-200 z-20 shadow-lg">
        <div className="font-bold mb-2 border-b border-gray-600 pb-1">
          DOL Overtime Calculation
        </div>

        <div className="text-xs mb-2 text-gray-700">
          DOL overtime premium is calculated using a blended rate based on total weekly earnings.
        </div>

        {/* Blended Rate Calculation Summary */}
        <div className="mb-2 p-2 bg-gray-300 rounded text-xs">
          <div className="font-semibold text-yellow-800 mb-1">
            Blended Rate Calculation
          </div>
          <div className="grid grid-cols-2 gap-1">
            <span className="">Total Earnings:</span>
            <span className="text-right ">${(dolBreakdown.totalEarnings || 0).toFixed(2)}</span>
            <span>Total Hours:</span>
            <span className="text-right">{(dolBreakdown.totalHours || 0).toFixed(2)}</span>
            <span className="text-yellow-800 font-semibold">Blended Rate:</span>
            <span className="text-right text-yellow-800 font-semibold">
              ${(dolBreakdown.blendedRate || 0).toFixed(2)}/hr
            </span>
          </div>
        </div>

        {/* OT Premium Calculation */}
        <div className="mb-2 p-2 bg-gray-100 rounded text-xs">
          <div className="font-semibold text-gray-700 mb-1">OT Premium Calculation</div>
          <div className="grid grid-cols-2 gap-1">
            <span>OT Premium Rate <br /> (Blended × 0.5):</span>
            <span className="text-right">${(dolBreakdown.otPremiumRate || 0).toFixed(2)}/hr</span>
            <span>OT Hours:</span>
            <span className="text-right">{(dolBreakdown.totalOvertimeHours || 0).toFixed(2)}</span>
            <span className="font-semibold text-green-700">OT Premium:</span>
            <span className="text-right font-semibold text-green-700">
              ${(dolBreakdown.overtimePremium || 0).toFixed(2)}
            </span>
          </div>
        </div>

        {/* Total Additional OT */}
        <div className="border-t border-gray-600 pt-1 mt-1">
          <div className="flex justify-between font-bold text-green-600">
            <span>Total Additional OT:</span>
            <span>${(dolBreakdown.totalAdditionalOT || 0).toFixed(2)}</span>
          </div>
        </div>

        {/* Formula Reference */}
        {/* <div className="mt-2 pt-1 border-t border-gray-600 text-xs text-gray-700">
          <div>Total Earnings = Base Pay + OT Pay + Collected Bonus</div>
          <div>Blended Rate = Total Earnings / Total Hours</div>
          <div>OT Premium = Blended Rate × 0.5 × OT Hours</div>
        </div> */}
      </div>
    </div>
  );
}
